import { render, staticRenderFns } from "./luminance.vue?vue&type=template&id=083bb4a3&scoped=true"
import script from "./luminance.vue?vue&type=script&lang=js"
export * from "./luminance.vue?vue&type=script&lang=js"
import style0 from "./luminance.vue?vue&type=style&index=0&id=083bb4a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083bb4a3",
  null
  
)

export default component.exports